import { StatsigUser } from '@statsig/react-bindings';

/**
 * @typedef {{
 *  user_id: string,
 *  current_displayed_user_id: number,
 *  user_email: string,
 *  project_id: string,
 *  parent_account_id?: string,
 *  runtime_version: string,
 *  platform_version?: string,
 *  region?: string,
 *  environment?: string
 * }} InitFeatureStoreData
 */

/**
 * Build Statsig user object from backend init data
 * @param {{ data: InitFeatureStoreData }}
 * @returns {StatsigUser}
 */
function domainToContract({ data }) {
  return {
    userID: data.current_displayed_user_id,
    country: data.region || 'unknown',
    privateAttributes: {
      email: data.user_email || '',
    },
    custom: {
      userId: data.user_id,
      currentDisplayedUserId: data.current_displayed_user_id,
      projectId: data.project_id || '',
      parentAccountId: data.parent_account_id || '',
      runtimeVersion: data.runtime_version || '',
      platformVersion: data.platform_version || '',
      environment: data.environment || 'unknown',
    }
  }
}

export default domainToContract
